<swiper-container #swiperRef *ngIf="loaded" [attr.aria-busy]="activeSlideIndex ? 'true' : null">
    <swiper-slide *ngFor="let item of items; index as index" [attr.aria-hidden]="!isActive(index)"
        [attr.tabindex]="!isActive(index) ? -1 : null">
        <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{item: item, active: isActive(index)}" />
    </swiper-slide>
</swiper-container>
